<template>
	<v-layout style="page-break-inside: avoid" class="financial-table-value-font-size">
		<v-flex xs1 d-flex class="financial-table-header-light-color">
			<v-card color='grey lighten-2'>
				<v-card-text>
					<strong>

					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-2'>
				<v-card-text>
					<strong>
						{{lp}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs5 d-flex>
			<v-card color='grey lighten-2'>
				<v-card-text style="padding-left: 5px; padding-right: 5px;">
					<strong>
						{{cost.description}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-2'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<span>
						{{formatMoney(costOfType(['z dotacji']))}}
					</span>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-2'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<span>
						{{formatMoney(costOfType([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe']))}}
					</span>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-2'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<span>
						{{formatMoney(costOfType(['odsetki', 'przychody']))}}
					</span>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-2'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<span>
						{{formatMoney(costOfType(['wkład rzeczowy']))}}
					</span>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card color='grey lighten-2'>
				<v-card-text style="padding-left: 0px; padding-right: 5px; text-align: right">
					<span>
						{{formatMoney(costOfType(['wkład osobowy']))}}
					</span>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Numbers} from "../../../utils/Numbers";

	export default {
		name: "FinalReportInvoicesSingleCost",

		mixins: [Numbers],

		computed: {
			lp () {
				if (!this.lpPrefix) {
					return this.cost.serialNumber;
				} else {
					return this.lpPrefix + "." + this.cost.serialNumber;
				}
			},
		},

		methods: {
			costOfType (types) {
				let result = 0;
				for (const division of this.cost.costDivisions) {
					if (types.indexOf(division.type) !== -1) {
						result += division.totalPrice;
					}
				}
				return result;
			},
		},

		props: {
			lpPrefix: {},
			cost: {},
		}
	};
</script>

<style scoped>

</style>